import { Link } from 'react-router-dom';
import { videoData } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

export default function VideoListSection() {
  const featuredVideos = videoData.slice(0, 8);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">为你精选的优质内容</p>
          </div>
          <Link
            to="/category/gaoxiao"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredVideos.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              coverImage={video.coverImage}
              duration={video.duration}
              views={video.views}
              author={video.author}
              authorAvatar={video.authorAvatar}
              category={video.category}
            />
          ))}
        </div>
      </div>
    </section>
  );
}